import { render, staticRenderFns } from "./img-select.vue?vue&type=template&id=2f3a93df&scoped=true"
import script from "./img-select.vue?vue&type=script&lang=js"
export * from "./img-select.vue?vue&type=script&lang=js"
import style0 from "./img-select.vue?vue&type=style&index=0&id=2f3a93df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a93df",
  null
  
)

export default component.exports